import { Component, ElementRef, ViewChild, OnInit, HostListener, TemplateRef } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { LayoutService } from '../../../services/layout/app.layout.service';
import { AuthService } from '../../auth/auth.service';
import { TopbarControlsService } from '../../../services/topbar-controls.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from '../../../models/models';
import { PendingChangesService } from '../../../services/pending-changes.service';
@Component({
	selector: 'app-topbar',
	templateUrl: './topbar.component.html',
	styleUrl: './topbar.component.scss'
})
export class TopbarComponent implements OnInit {
	items!: MenuItem[];
	isLoading: boolean = false;
	dropdownItems: MenuItem[] = [
		{
			label: 'Log Out',
			command: (event) => {
				this.onLogout();
			}
		}
	];

	loginModalSub!: Subscription;
	showLoginModal: boolean = false;
	loggedInUser: User | null = null;

	@ViewChild('dropdown') dropdown: any;

	@ViewChild('menubutton') menuButton!: ElementRef;

	@ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

	@ViewChild('topbarmenu') menu!: ElementRef;

	constructor(
		public layoutService: LayoutService,
		private authService: AuthService,
		public topbarControlsService: TopbarControlsService,
		private router: Router,
		private route: ActivatedRoute,
		private pendingChanges: PendingChangesService
	) {
		this.loginModalSub = this.layoutService.showLoginModal$.subscribe((open) => {
			this.showLoginModal = open;
			//   this.loggedInUser = this.authService.getLoggedInUser();
		});
	}

	ngOnInit(): void {
		this.loggedInUser = this.authService.getLoggedInUser();

		if (this.router.url.includes('dispatcher')) {
			this.layoutService.onMenuToggle(false);
		}
	}

	@HostListener('window:scroll')
	onWindowScroll() {
		this.dropdown?.hide();
	}

	onLogout() {
		// DOVE-2676 — logging out drops any unsent change rather than asking the user to stay.
		this.pendingChanges.discardAll();
		this.isLoading = true;
		// Session is cleared by the logout endpoint
		this.authService.logout().subscribe(
			(res) => {
				this.isLoading = false;
				this.router.navigate(['/auth/login']);
			},
			(err) => {
				this.isLoading = false;
				this.router.navigate(['/auth/login']);
			}
		);
	}

	get isAuthenticated() {
		return this.authService.isLoggedIn();
	}
}
